module.exports = __webpack_public_path__ + "static/img/modalTopLogo.tid100.2d466fe.png";